export enum FgaType {
  convo = 'convo',
  dataSource = 'data_source',
  prompt = 'prompt',
  team = 'team',
  topic = 'topic',
  user = 'user',
}
